import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SectionLayoutMetadata } from '../../../common-shared-module/model/dyn-form/form-metadata/layout/section-layout.model';
import { DynFormService } from '../../../common-shared-module/services/dyn-form/dyn-form.service';

@Injectable({
  providedIn: 'root'
})
export class EFormDynamicSectionMetadataService {

  cache:Map<number,SectionLayoutMetadata> = new Map()

  constructor(protected dynFormService:DynFormService) { 

  }

  loadSectionMetadata(sectionId:number) :Observable<SectionLayoutMetadata>{

    let section = this.cache.get(sectionId)
    if (section!=null){
      return of(section)
    }

    return this.dynFormService.loadSection(sectionId).pipe(map(s=>{
      this.cache.set(sectionId,s)
      return s
    }))
  }


  preloadSectionLayoutMetadata(sectionId:number,value:SectionLayoutMetadata){
    this.cache.set(sectionId,value)
  }

  clearCache():void{
    this.cache.clear()
  }
}
